import React, { useState } from 'react';
import { connect } from 'react-redux';

import { changeFormField } from 'apps/auth/actions/formAction';
import InputText from 'apps/auth/components/form-multi/InputText';
import { validationAndUpdateValue } from 'apps/auth/components/form-multi/utils';
import { useFields } from 'apps/auth/hooks/selectors';

import InputAutoCompletePostCodeList from './InputAutoCompletePostCodeList';
import ModalComponent from '../utils/ModalComponent';

const getItemView = (item) => ({
    id: item['id'] || '',
    mainText: item['address'] || '',
    city: item['city'] || '',
    streetAndHouseNo: item['addressLine2'] || '',
    apartment: item['addressLine1'] || '',
    postCode: item.postCode || '',
});

const InputAutoCompletePostCode = (props) => {
    const [items, setItems] = useState([]);
    const [selectedPostCode, setSelectedPostCode] = useState({
        postCode: '',
        id: '',
    });

    const [isOpenedDropbox, toggleDropbox] = useState(false);
    const openDropbox = () => toggleDropbox(true);
    const closeDropbox = () => toggleDropbox(false);

    const fields = useFields(props.formName);

    const selectItem = (e, item) => {
        const view = getItemView(item);

        if (fields && fields.city) {
            validationAndUpdateValue(props.formName, view.city, fields.city, props.changeFormField).then(() => closeDropbox);
        }

        if (fields && fields.address) {
            validationAndUpdateValue(props.formName, view.streetAndHouseNo, fields.address, props.changeFormField).then(() => closeDropbox);
        }

        if (fields && fields.address2) {
            validationAndUpdateValue(props.formName, view.apartment, fields.address2, props.changeFormField).then(() => closeDropbox);
        }

        if (fields && fields.post_code) {
            validationAndUpdateValue(props.formName, view.postCode, fields.post_code, props.changeFormField).then(() => closeDropbox);
        }

        setSelectedPostCode({ postCode: view.postCode, id: view.id });
        closeDropbox();
    };

    const selectInputClient = (e, value) => {
        if (fields && fields.post_code) {
            validationAndUpdateValue(props.formName, value, fields.post_code, props.changeFormField).then(() => closeDropbox);
        }
    };

    return (
        <>
            {!isOpenedDropbox ? (
                <InputText
                    onClick={openDropbox}
                    field={props.field}
                    formName={props.formName}
                    autoFocus={props.focus}
                    onFocus={openDropbox}
                    isClearErrorOnFocus={props.isClearErrorOnFocus}
                    onChange={props.onChange}
                    onBlur={props.onBlur}
                    validateOnBlur={false}
                    isNewInput
                    alwaysHasHint={props.alwaysHasHint}
                />
            ) : (
                <ModalComponent canCloseModal={false}>
                    <InputAutoCompletePostCodeList
                        selectItem={selectItem}
                        selectInputClient={selectInputClient}
                        items={items}
                        setItems={setItems}
                        field={props.field}
                        selectedPostCode={selectedPostCode}
                        searchPlaceholder={props.searchPlaceholder}
                        formName={props.formName}
                        onCloseButtonClick={closeDropbox}
                    />
                </ModalComponent>
            )}
        </>
    );
};

const mapStateToProps = ({ messages }) => ({
    searchPlaceholder: messages.jsMessages['site.field.search.placeholder'],
});

export default connect(mapStateToProps, { changeFormField })(InputAutoCompletePostCode);
